import { render, staticRenderFns } from "./brandMallMgt.vue?vue&type=template&id=aa2e7c14&scoped=true"
import script from "./brandMallMgt.vue?vue&type=script&lang=js"
export * from "./brandMallMgt.vue?vue&type=script&lang=js"
import style0 from "./brandMallMgt.vue?vue&type=style&index=0&id=aa2e7c14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2e7c14",
  null
  
)

export default component.exports